import React, { useState, useEffect } from "react";
import ParentPanel from "../panel/TeacherPanel";
import api from "../../../api/api";
import "../styles/assignment.css";

const TeacherAssignmentPage = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [assignments, setAssignments] = useState([]);
  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);
  const [subjects, setSubjects] = useState([]);

  const [newAssignment, setNewAssignment] = useState({
    classId: "",
    sectionId: "",
    subject: "",
    title: "",
    dueDate: "",
    type: "pdf",
    comment: "",
    file: null,
  });

  const token = localStorage.getItem("token");

  // Fetch teacher assignments
  const fetchAssignments = async () => {
    try {
      const res = await api.get("/api/assignments/teacher", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAssignments(res.data);
    } catch (err) {
      console.error("❌ Failed to fetch assignments:", err);
    }
  };

  // Fetch classes assigned to teacher
  const fetchClasses = async () => {
    try {
      const res = await api.get("/api/classes", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setClasses(res.data);
    } catch (err) {
      console.error("❌ Failed to fetch classes:", err);
    }
  };

  // Fetch sections for selected class
  const fetchSections = async (classId) => {
    if (!classId) return;
    try {
      const res = await api.get(`/api/sections?classId=${classId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSections(res.data);
      setNewAssignment(prev => ({ ...prev, sectionId: "", subject: "" }));
      setSubjects([]);
    } catch (err) {
      console.error("❌ Failed to fetch sections:", err);
    }
  };


// Fetch subjects for selected class + section
const fetchSubjects = async (classId, sectionId) => {
  if (!classId || !sectionId) return;
  try {
    const res = await api.get("/api/assignments/teacher-subjects", {
      headers: { Authorization: `Bearer ${token}` },
      params: { classId, sectionId },
    });
    // set the subject directly
    setNewAssignment(prev => ({ ...prev, subject: res.data[0] || "" }));
  } catch (err) {
    console.error("❌ Failed to fetch subjects:", err);
    setNewAssignment(prev => ({ ...prev, subject: "" }));
  }
};

  useEffect(() => {
    fetchAssignments();
    fetchClasses();
  }, []);

  // Handlers for dropdown cascade
  const handleClassChange = (classId) => {
    setNewAssignment(prev => ({ ...prev, classId, sectionId: "", subject: "" }));
    fetchSections(classId);
  };

  const handleSectionChange = (sectionId) => {
    setNewAssignment(prev => ({ ...prev, sectionId }));
    fetchSubjects(newAssignment.classId, sectionId);
  };

  const handleInputChange = (field, value) => {
    setNewAssignment(prev => ({ ...prev, [field]: value }));
  };

  const handleAddAssignment = async () => {
    try {
      const formData = new FormData();
      for (let key in newAssignment) {
        if (newAssignment[key] !== null) formData.append(key, newAssignment[key]);
      }

      await api.post("/api/assignments/teacher", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      alert("Assignment added!");
      setNewAssignment({
        classId: "",
        sectionId: "",
        subject: "",
        title: "",
        dueDate: "",
        type: "pdf",
        comment: "",
        file: null,
      });
      setSections([]);
      setSubjects([]);
      fetchAssignments();
    } catch (err) {
      console.error("❌ Failed to add assignment:", err);
    }
  };

  return (
    <>
      <ParentPanel onToggle={setIsSidebarCollapsed} />
      <div className={`parent-work-main ${isSidebarCollapsed ? "collapsed" : ""}`}>
        <h2>Teacher Assignments</h2>

        {/* Add Assignment Form */}
        <div className="add-assignment-form">
          {/* Class Dropdown */}
          <select
            value={newAssignment.classId}
            onChange={e => handleClassChange(e.target.value)}
          >
            <option value="">Select Class</option>
            {classes.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>

          {/* Section Dropdown */}
          <select
            value={newAssignment.sectionId}
            onChange={e => handleSectionChange(e.target.value)}
            disabled={!newAssignment.classId}
          >
            <option value="">Select Section</option>
            {sections.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>

{/* Subject - autofilled input */}
<input
  type="text"
  value={newAssignment.subject}
  readOnly
  placeholder="Subject will be auto-filled"
/>


          <input
            placeholder="Title"
            value={newAssignment.title}
            onChange={e => handleInputChange("title", e.target.value)}
          />
          <input
            type="date"
            value={newAssignment.dueDate}
            onChange={e => handleInputChange("dueDate", e.target.value)}
          />
          <select
            value={newAssignment.type}
            onChange={e => handleInputChange("type", e.target.value)}
          >
            <option value="pdf">PDF</option>
            <option value="video">Video</option>
            <option value="youtube">YouTube</option>
            <option value="image">Image</option>
            <option value="text">Text</option>
          </select>
          <input
            placeholder="Comment"
            value={newAssignment.comment}
            onChange={e => handleInputChange("comment", e.target.value)}
          />

          {/* Dynamic Input for file / text / YouTube */}
          {["pdf", "video", "image"].includes(newAssignment.type) && (
            <input
              type="file"
              accept={
                newAssignment.type === "pdf"
                  ? "application/pdf"
                  : newAssignment.type === "video"
                  ? "video/*"
                  : "image/*"
              }
              onChange={e => handleInputChange("file", e.target.files[0])}
            />
          )}
          {newAssignment.type === "youtube" && (
            <input
              placeholder="YouTube URL"
              value={newAssignment.file || ""}
              onChange={e => handleInputChange("file", e.target.value)}
            />
          )}
          {newAssignment.type === "text" && (
            <textarea
              placeholder="Enter text assignment"
              value={newAssignment.file || ""}
              onChange={e => handleInputChange("file", e.target.value)}
            />
          )}

          <button onClick={handleAddAssignment}>Add Assignment</button>
        </div>

        {/* Existing Assignments */}
        <div className="work-cards">
          {assignments.map(a => (
            <div key={a.id} className="assignment-card">
              <h4>{a.topic}</h4>
              <p>Subject: {a.subject}</p>
              <p>Due: {a.due_date}</p>
              <p>Section: {a.section_name}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default TeacherAssignmentPage;
